import CategoriesEntity from '@/entities/api/categories/category'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface CategoriesSlice {
	categories: CategoriesEntity[]
}

const initialState: CategoriesSlice = {
	categories: [],
}

const categoriesSlice = createSlice({
	name: 'categories',
	initialState,
	reducers: {
		setCategoriesFn: (state, action: PayloadAction<CategoriesEntity[]>) => {
			state.categories = action.payload
		},
	},
})

export const { setCategoriesFn } = categoriesSlice.actions

export default categoriesSlice.reducer
